<!-- <svelte:head>
  <script src="https://app.simplycast.com/?q=forms/getForm&i=5ff8652501ef94.84967906&type=modal"></script>
</svelte:head> -->
<script lang="ts">
  import { Router } from 'svelte-router-spa';
  import { routes } from './routes';
  import Navbar from "./Navbar.svelte";
  import Modal from "./components/Modal.svelte";
  import ContactForm from "./components/forms/ContactForm.svelte";
  import RequestDemoForm from "./components/forms/RequestDemoForm.svelte";
  import FooterSection from './sections/FooterSection.svelte';
  import SignUpSuccess from './components/SignUpSuccess.svelte';
  import { Toast } from './models/toast';

  export const initPage = () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  };

  let showModal = false;
  let modalTitle = '';
  let modalInner = '';
  let modalActions = [];
  let modalType = '';
  let showFreeTierlModal = false;
  let showBasicTierlModal = false;
  let showProTierlModal = false;
  let showEnterpriseTierlModal = false;
  let canSubmitModal = false;
  let currentRoute;
  const toast = new Toast({
    position: 'bottom-right',
    duration: 2500,
  });

  const onDismissModal = (e) => {
    showModal = false;
    canSubmitModal= false;
  }

  const onConfirmModal = (e) => {
    showModal = false;
    canSubmitModal= false;
  }
  const DEFAULT_MODAL_TYPE = 'confirm';
  const DEFAULT_MODAL_ACTIONS = [
    {
      label: 'Cancel',
      role: 'dismiss',
      handler: onDismissModal,
      cssClass: ['btn']
    },
    {
      label: 'Confirm',
      role: 'confirm',
      handler: onConfirmModal,
      cssClass: ['btn-secondary']
    }
  ];
  
  const onRequestADemo = (e) => {
    // modalTitle = 'Request a Demo';
    // showModal = true;
    // modalInner = 'request-demo';
    // modalType = DEFAULT_MODAL_TYPE;
    // modalActions = DEFAULT_MODAL_ACTIONS;
    // scDisplayModalForm('5ff8652501ef94.84967906');
    window.open('https://app.simplycast.com/?q=forms/take&i=5ff8652501ef94.84967906', '_blank');
  }

  const onContact = (e) => {
    modalTitle = 'Contact Us';
    showModal = true;
    modalInner = 'contact';
    modalType = DEFAULT_MODAL_TYPE;
    modalActions = DEFAULT_MODAL_ACTIONS;

    // toast.success('Message sent', {
    //   duration: 2500
    // });
  }
  
  let contactFormState = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    website: '',
  };
  const handleInput = (e) => {
    canSubmitModal = e.detail.canSubmit;
    contactFormState = e.detail.state;
  }

  export let url;

  const init = (e) => {
    url = location.pathname;
    toast.dismiss();
  }

  const onLiveDemo = (e) => {
    modalTitle = 'Live Demo';
    showModal = true;
    modalInner = 'live-demo';
    modalType = DEFAULT_MODAL_TYPE;
    modalActions = DEFAULT_MODAL_ACTIONS;
  }

  const onSignUpSuccess = (e) => {
    modalTitle = 'Congratulations';
    showModal = true;
    modalInner = 'sign-up-success';
    modalType = 'alert';
    modalActions = [
      {
        label: 'OK',
        role: 'confirm',
        handler: onConfirmModal,
        cssClass: ['btn-secondary']
      }
    ];
  }

  document.addEventListener('DOMContentLoaded', init, false);
  document.addEventListener('planselect', onContact, false);
  document.addEventListener('signupsuccess', onSignUpSuccess, false);
</script>

<main>
  <Modal
    title={modalTitle}
    isVisible={showModal}
    canSubmit={canSubmitModal}
    type={modalType}
    actions={modalActions}
    on:dismiss={onDismissModal}
    on:confirm={onConfirmModal}>
    {#if modalInner === 'contact'}
    <ContactForm on:input={handleInput} />
    {:else if modalInner === 'request-demo'}
    <RequestDemoForm />
    {:else if modalInner === 'live-demo'}
    <div>Live demo</div>
    {:else if modalInner === 'sign-up-success'}
    <SignUpSuccess />
    {/if}
  </Modal>
  <Navbar
    on:contact={onContact}
    on:requestademo={onRequestADemo}
    on:livedemo={onLiveDemo} />

  <Router {currentRoute} {routes} />

  <!-- Footer -->
  <FooterSection />
</main>